module.exports = __webpack_public_path__ + "static/media/Saratoga-Master-Deed.b72836b9.pdf";